// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"Pagination_Pagination__2Xt2h","pages":"Pagination_pages__2OKjg"};